export default __webpack_public_path__ + "static/media/STL_Newspaper_intimation.db106623.pdf";